import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { EndPointsApis } from '../services/EndPointsApis';

interface UserDetail {
  token?: string;
  expiresAt?: string;
  firstName?: string;
  lastName?: string;
  roleName?: string;
  imgURL?:string;
  userAccountInRoles?:any;
  userAccountInOrgs?:any;
}
interface Permission {
  id: number;
  view: boolean;
  edit: boolean;
  delete: boolean;
  create: boolean;
  assign: boolean;
  screenName: string;
}

interface AuthState {
  isLoggedIn: boolean;
  token?: string;
  expiresAt?: string;
  userDetail?: UserDetail;
  apiData?: any;
  lastApiCall?: number;
  permissions?:any;
  theme?:any;
  profileDetails?:any;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: AuthState = {
  isLoggedIn: false,
  status: 'idle',
  lastApiCall: undefined,
  token:""
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserDetail>) => {
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.expiresAt = action.payload.expiresAt;
      state.userDetail = action.payload;
    },
    setPermissionsState:(state,action: PayloadAction<Permission[]>)=>{
      state.permissions=action.payload;
    },
    setTheme:(state,action: PayloadAction<any>)=>{
      state.theme=action.payload;
    },
    logout: () => initialState,
    setApiData: (state, action: PayloadAction<any>) => {
      state.apiData = action.payload;      
    },
    setStatus: (state, action: PayloadAction<'idle' | 'loading' | 'succeeded' | 'failed'>) => {
      state.status = action.payload;
    },
    setProfileDetails:(state,action: PayloadAction<any>)=>{
      state.profileDetails = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(EndPointsApis.endpoints.getDefaultlookups.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(EndPointsApis.endpoints.getDefaultlookups.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        state.apiData = action.payload;
        state.lastApiCall = Date.now();
        localStorage.setItem('lastApiCall', state.lastApiCall.toString());
      })
      .addMatcher(EndPointsApis.endpoints.getDefaultlookups.matchRejected, (state) => {
        state.status = 'failed';
      });
  },
  
});

const persistConfig = {
  key: 'authSlice',
  storage,
};

const persistedReducer = persistReducer(persistConfig, authSlice.reducer);

export const { setUser, setApiData,setPermissionsState, setStatus,logout,setTheme,setProfileDetails } = authSlice.actions;
export default persistedReducer;
